const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

/**
 * GET /api/v1/admin/dashboard
 *
 * @param {Object} params
 * @param {string=} params.from - YYYY-MM-DD
 * @param {string=} params.to - YYYY-MM-DD
 * @param {number=} params.days
 * @param {string=} params.tz
 */
const getAdminDashboard = async (params = {}) => {
  const token = localStorage.getItem('token');

  const queryParams = new URLSearchParams();
  if (params.from) queryParams.append('from', params.from);
  if (params.to) queryParams.append('to', params.to);
  if (params.days !== undefined && params.days !== null && params.days !== '') {
    queryParams.append('days', String(params.days));
  }
  if (params.tz) queryParams.append('tz', params.tz);

  const qs = queryParams.toString();
  const response = await fetch(`${API_URL}/api/v1/admin/dashboard${qs ? `?${qs}` : ''}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return response.json();
};

export { getAdminDashboard };

